module.exports = __webpack_public_path__ + "assets/heart.4b7fe1f0.svg";